import { Icon } from '@iconify/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export function DynamicNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const threadDetalPage = location.pathname.includes('/t/');
  const discoverPage = location.pathname.includes('/discover');
  return (
    <div className="md:hidden">
      {location.pathname === '/' ? (
        <Link
          to="/"
          className="flex items-center space-x-2 rounded-2xl bg-indigo-50/90 px-4 py-2 text-indigo-900 shadow hover:text-indigo-800 hover:shadow-md focus-visible:text-indigo-800 supports-[backdrop-filter]:bg-indigo-100/30 supports-[backdrop-filter]:backdrop-blur dark:bg-gray-900/90 dark:text-indigo-100 dark:hover:bg-gray-900 dark:hover:text-indigo-200 dark:focus-visible:text-indigo-200 dark:supports-[backdrop-filter]:bg-gray-900/75 lg:bg-transparent lg:font-medium lg:shadow-none lg:hover:shadow-none"
        >
          <Icon className="lg:h-9 lg:w-9" icon="carbon:logo-discord" />
          <div className="lg:text-3xl lg:font-semibold">Diskord</div>
        </Link>
      ) : (
        <div className="flex items-center space-x-2 rounded-2xl bg-indigo-50/90 p-2 pr-4 shadow hover:text-indigo-800 hover:shadow-md focus-visible:text-indigo-800 supports-[backdrop-filter]:bg-indigo-100/30 supports-[backdrop-filter]:backdrop-blur dark:bg-gray-900/90 dark:hover:bg-gray-900 dark:hover:text-indigo-200 dark:focus-visible:text-indigo-200 dark:supports-[backdrop-filter]:bg-gray-900/75 lg:bg-transparent lg:font-medium lg:shadow-none lg:hover:shadow-none">
          <button
            onClick={() => navigate(-1)}
            title="back"
            className="h-full w-full px-2 text-indigo-900 hover:text-indigo-800 dark:text-indigo-100 dark:hover:text-indigo-200"
          >
            <Icon icon="heroicons:arrow-left-20-solid" />
          </button>
          <span className="empty:hidden">{discoverPage ? 'Discover' : ''}</span>
          <span className="empty:hidden">
            {threadDetalPage ? 'Thread' : ''}
          </span>
        </div>
      )}
    </div>
  );
}
